import Routes from './routes/Routes';
// ^5.22.3
//import { configureFakeBackend } from './helpers';

// Themes
// For Default import Theme.scss
import './assets/scss/Theme.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Themes-RTL
// For Default import Theme-RTL.scss
//import './assets/scss/Theme-RTL.scss';

// For Dark import Theme-Dark.scss
//import './assets/scss/Theme-Dark.scss';
const App = () => {
    return (
        <>            
            <ToastContainer position='top-center' rtl />
            <Routes></Routes>
        </>
    );
};

export default App;
